/* import __COLOCATED_TEMPLATE__ from './user-summary-users-list.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./user-summary-users-list.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({}));